// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueAnalytics from 'vue-analytics'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import TruffleContract from 'truffle-contract'
Object.defineProperty(Vue.prototype, '$TruffleContract', {value: TruffleContract})

import JSEncrypt from 'jsencrypt/bin/jsencrypt.min.js'
Object.defineProperty(Vue.prototype, '$JSEncrypt', {value: new JSEncrypt()})

Vue.use(VueAnalytics, {
  id: 'UA-35928340-2',
  router
})

Vue.use(BootstrapVue)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js